import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useQueryWithErrorHandling } from '@ts-private/apollo-tools';
import { gql } from '@apollo/client';
import { getContextName, getServiceRoute } from 'constants/contexts';
import { useOidcUser } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

const SERVICE_LIST = gql`
  query services {
    services {
      type
      name
      httpEndpoint
      wsEndpoint
    }
  }
`;

export const ServiceContext = createContext();
export const ServiceProvider = ({ children }) => {
  const [activeService, setActiveService] = useState(null);
  const [services, setServices] = useState([]);
  const { oidcUser } = useOidcUser(getOidcConfigName());

  const { loading } = useQueryWithErrorHandling(SERVICE_LIST, {
    skip: !oidcUser,
    onCompleted: data => {
      if (data && data.services) {
        const newServices = data.services.map(item => {
          return { ...item, displayName: getContextName(item.name), route: getServiceRoute(item.name) };
        });
        setServices([...services, ...newServices]);
      }
    }
  });

  return <ServiceContext.Provider value={[activeService, setActiveService, services, loading]}>{children}</ServiceContext.Provider>;
};
ServiceProvider.propTypes = { children: PropTypes.element.isRequired };
